
      import '@folkjs/labs/standalone/folk-space-attribute';
      import '@folkjs/labs/standalone/folk-camera-attribute';
      import '@folkjs/labs/standalone/folk-shape-attribute';
      import { videoFrameToImage } from '@folkjs/labs/utils/video';

      const GAP = 25;
      const video = document.querySelector('video');
      let lastShape = video;

      document.addEventListener('keypress', (e) => {
        if (e.code !== 'Space') return;

        const image = videoFrameToImage(video);
        image.setAttribute('folk-shape', `x: ${lastShape.folkShape.x}; y: ${lastShape.folkShape.bottom + GAP}`);
        document.body.appendChild(image);
        lastShape = image;
      });
    